import { Select } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import i18n from 'i18next';

import changeLanguage from '../helpers/changeLanguage';

const LanguageSwitcher = () => {
  const handleLanguageChange = (value: string) => {
    changeLanguage(value);

    // change dayjs locale
    if (value === 'en') {
      dayjs.locale('en');
    } else {
      dayjs.locale('ar');
    }
  };

  return (
    <Select
      style={{
        width: 120,
      }}
      onChange={handleLanguageChange}
      value={i18n.language}
      options={[
        {
          label: 'English',
          value: 'en',
        },
        {
          label: 'العربية',
          value: 'ar',
        },
      ]}
    />
  );
};

export default LanguageSwitcher;
